import { Offerte } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class iren10X2LuceServizi{
  public static  offerta ():Offerte {
      return {
		Flg_Indicizzato: false,
        Id_Offerta: 111,
        Id_Foritore: 1,
        Id_comodity: 1,
        TipoContratto:1,
        NomeOfferta: "IREN 10x2 Luce Servizi",
        LinkFoto: "./assets/images/offerte-iren/10X2-ele-servizi.jpg",
        LinkFotoLarge: "./assets/images/offerte-iren/10X2-ele-servizi.jpg",
        LinkFotoMid: "./assets/images/offerte-iren/10X2-ele-servizi.jpg",
        LinkFotoSm: "./assets/images/offerte-iren/10X2-ele-servizi.jpg",
        LinkFotoCarousel: "./assets/images/offerte-iren/10X2-ele-servizi.jpg",
        DescrizioneCarousel: "Che Offerta super",
        DescrizioneNomeOfferta: "Una proposta che ti offre un servizio luce conveniente per il tuo ufficio o per la tua impresa.",
        PromozioneOfferta: "",
        Sezioni: [
          {
            NomeSezione: "RISPARMIO ASSICURATO",
            DescrizioneSezione:"Aderendo alla presente offerta il cliente avrà un bonus di 20 € sulla sua fornitura di energia elettrica, che verrà suddiviso in 2 bonus da 10 € ciascuno: 10 € sulla prima bolletta ed i restanti 10 € sulla prima bolletta utile allo scadere della competenza del 1° anno di fornitura. ",
            lstPunti: []
          },
        ],
        PrezzoEle: 0.0825,
        PrezzoGas: 0,
       
        TitoloPlus: "RISPARMIO ASSICURATO",
        Plus: ["Una proposta che ti offre un servizio luce conveniente per il tuo ufficio o per la tua impresa.",]
        ,schedaconfrontabilitaele:  { tabellaConfrontabilita:[]}

        ,schedaconfrontabilitagas:
        {
          tabellaConfrontabilita:[]
        }
        ,lstModalitaPagamento :["1","2"]
        ,scontoRid:0 
        ,TipoSoglieEle: Soglie.SoglieEle4Fasce()
        ,ImportoAnnuoLordo: 0
        ,ImportoAnnuoNetto: 0
        ,ImportoMensileLordo: 0
        ,ImportoMensileNetto: 0
        ,iscopertura: "" 
      };
    }
}



// WEBPACK FOOTER //
// ./src/app/archivioofferte/iren10X2LuceServizi.ts